/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React, { Component } from 'react';
import {
    Route, Routes,
} from 'react-router-dom';

import AdminListsContainer from "./AdminListsContainer";
import AdminImportListContainer from "./AdminImportListContainer";
import AdminListProcessContainer from "./AdminListProcessContainer";
import AdminListParseContainer from "./AdminListParseContainer";
import AdminListNormalizeContainer from "./AdminListNormalizeContainer";
import AdminListMatchContainer from "./AdminListMatchContainer";
import AdminListSyncContainer from "./AdminListSyncContainer";
import AdminListReSyncContainer from './AdminListReSyncContainer'
import AdminEditListContainer from "./AdminEditListContainer";
import AdminDownloadListContainer from './AdminDownloadListContainer';
import AdminViewAsJSONContainer from "./AdminViewAsJSONContainer";
import AdminCreateListMatchReportContainer from "./AdminCreateListMatchReportContainer";
import AdminListMatchCheckContainer from "./AdminListMatchCheckContainer";
import AdminViewListMatchReportContainer from "./AdminViewListMatchReportContainer";

export default class AdminListsRouter extends Component {
    static propTypes = {

    };

    static defaultProps = {

    };

    render() { // eslint-disable-line
        return (
            <Routes>
                <Route path="/import" element={<AdminImportListContainer/>} />
                <Route path="/:id/process" element={<AdminListProcessContainer/>} />
                <Route path="/:id/parse" element={<AdminListParseContainer/>} />
                <Route path="/:id/normalize" element={<AdminListNormalizeContainer/>} />
                <Route path="/:id/re-sync" element={<AdminListReSyncContainer/>} />
                <Route path="/:id/sync" element={<AdminListSyncContainer/>} />
                <Route path="/:id/edit" element={<AdminEditListContainer/>} />
                <Route path="/:id/download" element={<AdminDownloadListContainer/>} />
                <Route path="/:id/match" element={<AdminListMatchContainer/>} />
                <Route path="/:id/match-check" element={<AdminListMatchCheckContainer/>} />
                <Route path="/:id/view-as-json" element={<AdminViewAsJSONContainer/>} />
                <Route path="/:id/create-list-match-report" element={<AdminCreateListMatchReportContainer/>} />
                <Route path="/:id/view-match-report" element={<AdminViewListMatchReportContainer/>} />
                <Route path="/" element={<AdminListsContainer/>} />
            </Routes>
        );
    }
}
